<template>
  <BaseButton
    class="type-body-sm font-medium text-red underline hover:no-underline"
  >
    Remove
  </BaseButton>
</template>
